import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=760beb20&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=760beb20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760beb20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760beb20')) {
      api.createRecord('760beb20', component.options)
    } else {
      api.reload('760beb20', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=760beb20&scoped=true", function () {
      api.rerender('760beb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Accounts.vue"
export default component.exports